import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import Link from 'react-router/lib/Link';

import Icon, { GLYPHS } from '../../../common/icon';
import withToggle from '../../../common/hoc/withToggle';
import IntegrationSpinner from './IntegrationSpinner';

const IntegrationCard = (
  {
    connectionLink,
    description,
    descriptionIsOn,
    descriptionOn,
    descriptionOff,
    imageSrc,
    isConnected,
    loading,
    settingsLink,
    title,
  }) => (
    <div
      data-automation-id={`integrations-card-${title}`}
      className={classNames('integrations-card', { 'show-description': descriptionIsOn })}
    >
      <div className="integrations-card__icon" onMouseOver={descriptionOn} onMouseOut={descriptionOff}>
        <Icon glyph={GLYPHS.info} />
      </div>
      <div className="integrations-card__initial integrations-card__inner">
        <div className="integrations-card__title">
          <img className="integrations-card__logo" alt="integrations-card" src={imageSrc} />
          {title}
        </div>
        <div
          display-if={isConnected && !loading}
          className="integrations-card__status u-font-color-green"
        >
          Connected
        </div>
        <IntegrationSpinner display-if={loading} />
        <Link
          display-if={isConnected && !loading}
          to={settingsLink}
          className="u-font-color-primary u-width-120 u-mr-- u-mr0"
        >
        Manage
      </Link>
        <Link
          display-if={!isConnected && !loading}
          className="c-btn c-btn--medium c-btn--grey"
          to={connectionLink}
        >
        Connect
      </Link>
      </div>
      <div className="integrations-card__hovered integrations-card__inner">
        <div className="integrations-card__title">
          <img className="integrations-card__logo" alt="integrations-card" src={imageSrc} />
          {title}
        </div>
        <div className="integrations-card__description">
          {description}
        </div>
      </div>
    </div>
  );

IntegrationCard.propTypes = {
  connectionLink: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  descriptionIsOn: PropTypes.bool.isRequired,
  descriptionOn: PropTypes.func.isRequired,
  descriptionOff: PropTypes.func.isRequired,
  imageSrc: PropTypes.string.isRequired,
  isConnected: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  settingsLink: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default compose(
  withToggle('description'),
)(IntegrationCard);
